module.exports = __webpack_public_path__ + "static/media/blaster.4bc5f66f.png";